import { BaccaratValues, CellStyles, DEFAULT_CELL_FONT_SIZE, MAX_COLUMNS_COUNT, MAX_ROWS_COUNT } from './constants';
import { BaccaratBaseValues } from './types';

export const shiftTableResults = (table: string[][]) => {
    return table.map((row) => {
        const newRow = row.slice(1);
        newRow.push('');

        return newRow;
    });
};

export const getClosestNotTieResult = (array: string[], positionTo: number) => {
    return array.slice(0, positionTo).reverse()
        .find((letter: string) => letter[0] !== BaccaratValues.Tie)?.[0];
};

export const isBottomCellOccupied = (array: string[][], row: number, column: number) => {
    const cellData = array[row + 1]?.[column];

    return !(cellData === '');
};

export const convertResultsToTable = (results: string[]) => {
    let tableData = Array(MAX_ROWS_COUNT).fill('')
        .map(() => Array(MAX_COLUMNS_COUNT).fill(''));

    let currentRow = 0;
    let currentColumn = 0;
    let dragonColumn = 0;

    results?.reduce((prevSymbol: string, curr: string, index, array) => {
        const currentSymbol = curr?.[0];
        const closestResult = getClosestNotTieResult(array, index);

        if (currentSymbol !== BaccaratValues.Tie) {
            if (closestResult && currentSymbol === closestResult) {
                if (isBottomCellOccupied(tableData, currentRow, currentColumn + dragonColumn)) {
                    dragonColumn += 1;
                } else {
                    currentRow += 1;
                }
            } else if (closestResult && closestResult !== currentSymbol) {
                dragonColumn = 0;
                currentRow = 0;
                currentColumn += 1;
            }

            if (currentColumn + dragonColumn >= MAX_COLUMNS_COUNT) {
                if (currentColumn === 0 && dragonColumn > 0) {
                    dragonColumn -= 1;
                } else {
                    currentColumn -= 1;
                }

                tableData = shiftTableResults(tableData);
            }
        }

        tableData[currentRow][currentColumn + dragonColumn] += currentSymbol;

        return currentSymbol;
    }, '');

    return tableData;
};

export const getCellConfiguration = (cell: string) => {
    const classes: string[] = [];

    const tiesCount = cell.split(BaccaratValues.Tie).length - 1;
    const notTieLetter = [...cell].filter(letter => letter !== BaccaratValues.Tie)?.[0];

    if (tiesCount > 0) {
        classes.push(CellStyles.WithTie);
    }

    if (notTieLetter) {
        classes.push(CellStyles[notTieLetter as BaccaratBaseValues]);
    }

    return {
        classes,
        tiesCount
    };
};

export const calculateFontSize = (element: HTMLDivElement | null) => {
    if (element) {
        const { height } = element.getBoundingClientRect();
        const fontSize = Math.floor((height - MAX_ROWS_COUNT - 1) / MAX_ROWS_COUNT);

        return fontSize;
    }

    return DEFAULT_CELL_FONT_SIZE;
};
